import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=432d510e&scoped=true&"
import script from "./Verification.vue?vue&type=script&lang=ts&"
export * from "./Verification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432d510e",
  null
  
)

export default component.exports